import HostPlanPurchaseService from 'service/HostPlanPurchaseService';

/**
 * The "Host Pro" badge and nav links elsewhere read planType from a cached login snapshot in localStorage. Call this once a
 * listing really carries a paid plan (after the purchase is tagged), so they show it without a new login.
 */
export const markAccountPremium = (): void => {
  try {
    const raw = localStorage.getItem('userDetails');
    if (raw) localStorage.setItem('userDetails', JSON.stringify({ ...JSON.parse(raw), planType: 'premium' }));
  } catch {
    // localStorage unavailable or the snapshot is not JSON: the badge simply updates at the next login
  }
};

export type PurchaseStatus = 'PENDING' | 'SUCCESS' | 'FAILED';

/**
 * Asks the backend about a purchase until it leaves PENDING (a payment id is not a settled payment: UPI and netbanking can
 * still fail or stay pending). Returns 'ABORTED' when `stillWanted` turns false (the screen was left), and 'PENDING' when it
 * is still undecided after all the attempts.
 */
export const settlePurchaseStatus = async (
  purchaseId: number,
  stillWanted: () => boolean = () => true,
  attempts = 15,
  intervalMs = 2000,
): Promise<PurchaseStatus | 'ABORTED'> => {
  for (let attempt = 0; attempt < attempts; attempt += 1) {
    let status: PurchaseStatus = 'PENDING';
    try {
      status = (await HostPlanPurchaseService.verify(purchaseId)).status;
    } catch {
      // transient: keep polling
    }
    if (!stillWanted()) return 'ABORTED';
    if (status !== 'PENDING') return status;
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
  return 'PENDING';
};
